import { render, staticRenderFns } from "./BaseTLTreeViewCheckItem.vue?vue&type=template&id=24d5e874&"
import script from "./BaseTLTreeViewCheckItem.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTreeViewCheckItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports